// extracted by mini-css-extract-plugin
export default {"nav_game":"game_nav_game__qulzj","call":"game_call__H31cW","sprint":"game_sprint__MsVDZ"};